import * as React from 'react';
import { cn } from '../../lib/utils';

export interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {}

const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ className, type, ...props }, ref) => {
    return (
      <input
        type={type}
        className={cn(
          'flex h-9 w-full rounded-md border border-[#095D52] bg-[#0B222C] px-3 py-1 text-sm text-[#ede8c5] shadow-sm transition-colors file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-[#ede8c5] placeholder:text-[#8aa39d] focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-[#bbe425] disabled:cursor-not-allowed disabled:opacity-50',
          className
        )}
        ref={ref}
        {...props}
      />
    );
  }
);
Input.displayName = 'Input';

export { Input };
